import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "heumieum-upload-request-page" }
const _hoisted_2 = { class: "console-page-head" }
const _hoisted_3 = { class: "console-head-side" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "hur-summary" }
const _hoisted_6 = { class: "hur-stat-value" }
const _hoisted_7 = { class: "hur-stat-value" }
const _hoisted_8 = { class: "hur-stat-value" }
const _hoisted_9 = { class: "hur-search" }
const _hoisted_10 = { class: "console-panel" }
const _hoisted_11 = { class: "hur-table" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "hur-facility" }
const _hoisted_14 = { class: "hur-facility-name" }
const _hoisted_15 = {
  key: 0,
  class: "hur-facility-code"
}
const _hoisted_16 = { class: "hur-bank" }
const _hoisted_17 = {
  key: 0,
  class: "hur-bank-name"
}
const _hoisted_18 = { class: "hur-memo" }

import { computed, onMounted, ref } from 'vue';
import LoadingOverlay from '@/components/common/LoadingOverlay.vue';
import { closingApi } from '@/services/api';

interface RequestItem {
  memberName: string;
  memberCode: string;
  bizGubun: string;
  year: number;
  month: number;
  bankAlias: string;
  bankName: string;
  status: 'requested' | 'completed' | string;
  requestType: string;
  requestedAt: string | null;
  completedAt: string | null;
  memo: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeumieumUploadRequestPage',
  setup(__props) {

const loading = ref(false);
const items = ref<RequestItem[]>([]);
const requestedCount = ref(0);
const completedCount = ref(0);
const statusFilter = ref<'all' | 'requested' | 'completed'>('requested');
const keyword = ref('');

const filteredItems = computed(() => {
  const word = keyword.value.trim().toLowerCase();
  return items.value.filter((item) => {
    if (statusFilter.value !== 'all' && item.status !== statusFilter.value) return false;
    if (!word) return true;
    const haystack = [item.memberName, item.memberCode, item.bankAlias, item.bankName, item.bizGubun]
      .join(' ')
      .toLowerCase();
    return haystack.includes(word);
  });
});

const statusLabel = (status: string) => (status === 'completed' ? '완료' : '등록요청');

const formatPeriod = (item: RequestItem) => {
  const month = String(item.month || '').padStart(2, '0');
  return `${item.year}.${month}`;
};

const formatDateTime = (value: string | null) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  return `${y}.${m}.${d} ${h}:${min}`;
};

const rowKey = (item: RequestItem, index: number) => {
  return `${item.memberCode}_${item.year}_${item.month}_${item.bankAlias}_${index}`;
};

const loadItems = async () => {
  loading.value = true;
  try {
    const response = await closingApi.heumieumRequestBoard();
    const data = response.data?.data || {};
    items.value = data.items || [];
    requestedCount.value = Number(data.requested || 0);
    completedCount.value = Number(data.completed || 0);
  } catch (error: any) {
    items.value = [];
    requestedCount.value = 0;
    completedCount.value = 0;
    const message = error.response?.data?.message || error.message || '조회에 실패했습니다.';
    window.alert(message);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  loadItems();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      show: loading.value,
      text: "불러오는 중...",
      variant: "light"
    }, null, 8, ["show"]),
    _createElementVNode("header", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "console-page-copy" }, [
        _createElementVNode("p", { class: "console-kicker" }, "슈퍼바이저"),
        _createElementVNode("h2", { class: "console-title" }, "희망이음 업로드"),
        _createElementVNode("p", { class: "console-desc" }, "기관이 올린 등록요청과 완료 내역입니다.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          class: "hur-refresh",
          disabled: loading.value,
          onClick: loadItems
        }, " 새로고침 ", 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["hur-stat", { active: statusFilter.value === 'all' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (statusFilter.value = 'all'))
      }, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(items.value.length), 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "hur-stat-label" }, "전체", -1))
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["hur-stat is-requested", { active: statusFilter.value === 'requested' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (statusFilter.value = 'requested'))
      }, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(requestedCount.value), 1),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "hur-stat-label" }, "등록요청", -1))
      ], 2),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["hur-stat is-completed", { active: statusFilter.value === 'completed' }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (statusFilter.value = 'completed'))
      }, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(completedCount.value), 1),
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "hur-stat-label" }, "완료", -1))
      ], 2),
      _createElementVNode("label", _hoisted_9, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((keyword).value = $event)),
          type: "text",
          placeholder: "기관, 통장, 기관기호"
        }, null, 512), [
          [_vModelText, keyword.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("table", _hoisted_11, [
        _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "기관"),
            _createElementVNode("th", null, "사업구분"),
            _createElementVNode("th", null, "연월"),
            _createElementVNode("th", null, "통장"),
            _createElementVNode("th", null, "상태"),
            _createElementVNode("th", null, "요청일시"),
            _createElementVNode("th", null, "완료일시"),
            _createElementVNode("th", null, "메모")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (!loading.value && filteredItems.value.length === 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [...(_cache[8] || (_cache[8] = [
                _createElementVNode("td", {
                  colspan: "8",
                  class: "hur-empty"
                }, "표시할 요청이 없습니다.", -1)
              ]))]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: rowKey(item, index)
            }, [
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(item.memberName || '-'), 1),
                  (item.memberCode)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(item.memberCode), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", null, _toDisplayString(item.bizGubun || '-'), 1),
              _createElementVNode("td", null, _toDisplayString(formatPeriod(item)), 1),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(item.bankAlias || '-'), 1),
                  (item.bankName)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.bankName), 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("span", {
                  class: _normalizeClass(["hur-badge", item.status === 'completed' ? 'is-completed' : 'is-requested'])
                }, _toDisplayString(statusLabel(item.status)), 3)
              ]),
              _createElementVNode("td", null, _toDisplayString(formatDateTime(item.requestedAt)), 1),
              _createElementVNode("td", null, _toDisplayString(item.status === 'completed' ? formatDateTime(item.completedAt) : '-'), 1),
              _createElementVNode("td", _hoisted_18, _toDisplayString(item.memo || '-'), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})